import { render, staticRenderFns } from "./AppMenu.vue?vue&type=template&id=c8c7b3a6&scoped=true&"
import script from "./AppMenu.vue?vue&type=script&lang=js&"
export * from "./AppMenu.vue?vue&type=script&lang=js&"
import style0 from "./AppMenu.vue?vue&type=style&index=0&id=c8c7b3a6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8c7b3a6",
  null
  
)

export default component.exports